import { useRouter } from "next/router";
import { useMemo } from "react";

export type PaginationDefaultLimit = 10 | 20 | 30 | 40 | 50;

export const usePaginationParams = (
  defaultLimit: PaginationDefaultLimit = 10
) => {
  const router = useRouter();

  const { page = 1, limit = defaultLimit } = router.query;
  const parsedPage = Number(page);
  const parsedLimit = Number(limit);
  const result = useMemo(
    () => ({
      offset: `${(parsedPage - 1) * parsedLimit}`,
      limit: `${parsedLimit}`,
      page: `${parsedPage}`,
    }),
    [parsedPage, parsedLimit]
  );

  return [result, parsedPage] as const;
};
